import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../../authentication.service';
import {HttpClient, HttpEvent, HttpEventType} from '@angular/common/http';
import {GlobalService} from '../../../global.service';
import {teamsService} from '../teams.service';
import {ActivatedRoute, Route, Router} from '@angular/router';
import {JoinTeamModalComponent} from '../join-team-modal/join-team-modal.component';
import {MatDialog} from '@angular/material';
import {UsersService} from '../../users/users.service';

@Component({
  selector: 'elastic-team-detail',
  templateUrl: './team-detail.component.html',
  styleUrls: ['./team-detail.component.scss']
})
export class TeamDetailComponent implements OnInit {

  teamId: any = 0;
  team = { members: []};
  teamLoaded = false;
  amIAdmin = false;
  teamAdmin = false;

  adminCount = 0;

  sim = 1;

  constructor(private userService: UsersService, private dialog: MatDialog, private route: ActivatedRoute, private cdr: ChangeDetectorRef, private auth: AuthenticationService, private httpClient: HttpClient, private globalService: GlobalService, private teamsService: teamsService) { }

  ngOnInit() {

    this.teamId = this.route.snapshot.paramMap.get('id');

    if (this.teamId !== 0) {
      this.getData();
    }

  }

  joinTeam(team) {
    this.dialog.open(JoinTeamModalComponent, {
      data: {team}
    }).afterClosed().subscribe(resp => {
      if (resp) {
        //console.log(resp);
        this.teamAdmin = false;
        this.amIAdmin = false;
        this.getData();
      }
    });
  }

  getData() {
    this.teamsService.getTeam(this.teamId, this.sim).subscribe(
      ( response: HttpEvent<any> ) => {
        switch (response.type) {
          case HttpEventType.Response:
            this.team = response.body.data;
            this.teamLoaded = true;
            this.team.members.forEach((item) => {
              if (item.id*1 === this.auth.getUserId()*1) {
                this.amIAdmin = true;
                if (item.team_admin*1 == 1) {
                  this.teamAdmin = true;
                }
              }
              if (item.team_admin == 1) {
                this.adminCount = this.adminCount + 1;
              }
            });

            this.cdr.detectChanges();
            break;
        }
      });
  }

  leaveTeam() {
    if ( (this.amIAdmin && !this.teamAdmin) || (this.teamAdmin && this.adminCount >= 2)) {
      if (confirm("Do you really want to leave that team?")) {
        this.userService.leaveTeam(this.teamId).subscribe(
          ( response: HttpEvent<any> ) => {
            switch (response.type) {
              case HttpEventType.Response:
                alert('You successfully left the team');
                this.getData();
                this.amIAdmin = false;
                this.teamAdmin = false;
                break;
            }
          });
      }
    }

  }

  removeMember(driver, team) {
    if (confirm("Are you sure?")) {
      this.teamsService.removeMember(driver, team).subscribe((data) => {
        this.getData();
      });
    }
  }

  makeAdmin(driver, team) {
    if (confirm("Are you sure?")) {
      this.teamsService.makeAdmin(driver, team).subscribe((data) => {
        this.getData();
      });
    }
  }

  removeAdmin(driver, team) {
    if (confirm("Are you sure?")) {
      this.teamsService.removeAdmin(driver, team).subscribe((data) => {
        this.getData();
      });
    }
  }

}
